// Generated by scripts/update-seeq-icons.js from src/svg/seeq/delete.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcDelete = {
  prefix: 'fak',
  iconName: 'delete' as IconName,
  icon: [
    1024,
    1024,
    [],
    'e927',
    'M1003.5 76.8l-51.2-51.2c-30.7-30.7-76.8-30.7-107.5 0l-332.8 327.7-332.8-332.8c-30.7-25.6-76.8-25.6-102.4 0l-51.2 51.2c-30.7 30.7-30.7 76.8 0 107.5l327.7 332.8-332.8 332.8c-30.7 30.7-30.7 76.8 0 107.5l51.2 51.2c30.7 30.7 76.8 30.7 107.5 0l332.8-332.8 332.8 332.8c30.7 30.7 76.8 30.7 107.5 0l51.2-51.2c30.7-30.7 30.7-76.8 0-107.5l-332.8-332.8 332.8-332.8c25.6-30.7 25.6-76.8 0-102.4z',
  ],
} satisfies IconDefinition;
